"use client";

import { Megaphone } from "lucide-react";
import { Link } from "react-router-dom";

import { Popover } from "@/components/ui-system";
import type { Announcement } from "@/lib/api/endpoints/announcements";

export type AnnouncementMenuProps = { items: Announcement[]; unread: number; loading?: boolean };

export function AnnouncementMenu({ items, unread, loading }: AnnouncementMenuProps) {
  return (
    <Popover
      placement="bottom-end"
      ariaLabel="Announcements"
      contentClassName="max-h-[min(30rem,calc(100vh-6rem))] w-[min(22rem,calc(100vw-2rem))] overflow-y-auto p-0"
      trigger={
        <span className="relative inline-flex h-10 w-10 items-center justify-center rounded-control border border-card-border bg-surface-primary text-muted shadow-raised transition-colors hover:bg-surface-hover hover:text-foreground">
          <Megaphone className="h-4 w-4" aria-hidden />
          {unread > 0 ? <span className="absolute right-0 top-0 flex h-5 min-w-5 translate-x-1/4 -translate-y-1/4 items-center justify-center rounded-full border-2 border-surface-primary bg-accent px-1 text-micro font-bold leading-none text-accent-foreground shadow-raised">{unread > 9 ? "9+" : unread}</span> : null}
        </span>
      }
    >
      {(close) => (
        <>
          <div className="flex items-center justify-between border-b border-card-border px-ds-4 py-ds-3"><div><p className="text-caption font-semibold">Announcements</p><p className="text-micro text-muted">{unread} unread</p></div><Link to="/announcements" onClick={close} className="text-micro font-semibold text-accent hover:underline">View all</Link></div>
          <div className="p-ds-2">
            {loading ? <p className="px-ds-3 py-ds-5 text-center text-caption text-muted">Loading announcements…</p> : items.length === 0 ? <p className="px-ds-3 py-ds-5 text-center text-caption text-muted">No announcements</p> : items.slice(0, 5).map((item) => (
              <Link key={item.id} to={`/announcements/${item.id}`} onClick={close} className="flex gap-ds-2 rounded-control px-ds-3 py-ds-3 hover:bg-surface-hover">
                <Megaphone className="mt-0.5 h-4 w-4 shrink-0 text-accent" aria-hidden />
                <span className="min-w-0"><span className="block truncate text-caption font-semibold">{item.title}</span><span className="mt-ds-1 block text-micro text-muted">{item.is_read ? "Read" : "Unread"} · {new Date(item.created_at).toLocaleDateString()}</span></span>
              </Link>
            ))}
          </div>
        </>
      )}
    </Popover>
  );
}
